import {cssTheme} from '@logistics-frontend/blocks'
import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

const pvzMarkSelected = css`
  background-color: ${cssTheme.colors.deliveryGrey[400]};
`

export const classes = {
  pvzMarkContainer: css`
    border-radius: ${spacing(1.5)};
    inset-inline-start: -50%;
    inset-block-start: -${spacing(6)};
    padding: ${spacing(1)};
    position: relative;

    & * {
      white-space: nowrap;
    }

    &:after {
      block-size: 0;
      border-inline-start: 10px solid transparent;
      border-inline-end: 10px solid transparent;
      border-block-start: 8px solid ${cssTheme.default.day.backgroundMinor};
      content: '';
      inset-block-end: -7px;
      inset-inline-start: calc(50% - 20px / 2);
      inline-size: 0;
      position: absolute;
    }

    &.${pvzMarkSelected}:after {
      border-block-start: solid ${cssTheme.colors.deliveryGrey[400]};
    }
  `,
  pvzMarkSelected,
  invert: css`
    filter: invert(1);
  `,
}
